/**
 * RevisionsInboxPage — full-screen view of /reviews/revisions-for-me.
 *
 * The RevisionsInboxWidget is embedded on every dashboard, but admins
 * and PMs benefit from a dedicated page that lists every pending
 * revision across the studio. Linked from the sidebar.
 */
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import RevisionsInboxWidget from '@/components/RevisionsInboxWidget';
import { useAuth } from '@/contexts/AuthContext';

export default function RevisionsInboxPage() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-100" data-testid="revisions-inbox-page">
      <div className="max-w-6xl mx-auto px-6 py-8">
        <div className="mb-6">
          <h1 className="text-2xl font-semibold tracking-tight flex items-center gap-2">
            <AlertTriangle className="w-6 h-6 text-amber-400" />
            Revisions inbox
          </h1>
          <p className="text-sm text-zinc-400 mt-1 max-w-3xl">
            Every submission currently flagged for revisions, with the reviewer's
            pin notes inline. Updated in real time as supervisors and clients
            mark feedback.
          </p>
        </div>
        <RevisionsInboxWidget />
      </div>
    </div>
  );
}
